/**
 * ChunkLoadError 対策プラグイン
 *
 * デプロイ後やネットワーク不安定時にチャンクファイルの読み込みに失敗した場合、
 * 自動的にページをリロードして最新版を取得する。
 * sessionStorage でリロード回数を管理し、上限(2回)を超えたらエラー表示。
 * sessionStorageが使えない環境ではリロードせずエラー画面を表示。
 */
export default function ({ app }) {
  if (!process.client) return

  const RELOAD_COUNT_KEY = 'chunk_error_reload_count'
  const RELOAD_TIME_KEY = 'chunk_error_reload_time'
  const MAX_RELOADS = 2
  const RESET_INTERVAL = 60000 // 60秒経過でカウントリセット

  let storageAvailable = true
  try {
    sessionStorage.setItem('__storage_test__', '1')
    sessionStorage.removeItem('__storage_test__')
  } catch {
    storageAvailable = false
  }

  const showUpdateError = () => {
    // Service Workerを解除して次回起動時にクリーンな状態にする
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(regs =>
        regs.forEach(r => r.unregister())
      )
    }

    document.body.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:center;min-height:100vh;padding:24px;font-family:-apple-system,sans-serif;">
        <div style="text-align:center;max-width:320px;">
          <p style="font-size:16px;font-weight:bold;margin-bottom:12px;">アプリの更新に失敗しました</p>
          <p style="font-size:14px;color:#666;margin-bottom:20px;">アプリを一度閉じて、再度開いてください。</p>
          <button onclick="try{sessionStorage.removeItem('chunk_error_reload_count')}catch(e){} window.location.reload()" style="padding:12px 24px;font-size:14px;background:#1976d2;color:#fff;border:none;border-radius:8px;cursor:pointer;margin-bottom:16px;">再読み込み</button>
          <p style="font-size:12px;color:#999;">解決しない場合はアプリの再インストールをお試しください。</p>
        </div>
      </div>
    `
  }

  const reloadIfNeeded = () => {
    // sessionStorageが使えない場合はリロードせずエラー画面を表示（無限ループ防止）
    if (!storageAvailable) {
      showUpdateError()
      return
    }

    const now = Date.now()
    const lastTime = parseInt(sessionStorage.getItem(RELOAD_TIME_KEY) || '0', 10) || 0
    let count = parseInt(sessionStorage.getItem(RELOAD_COUNT_KEY) || '0', 10) || 0

    // 一定時間経過していたらカウントリセット
    if (now - lastTime > RESET_INTERVAL) {
      count = 0
    }

    if (count >= MAX_RELOADS) {
      showUpdateError()
      return
    }

    sessionStorage.setItem(RELOAD_COUNT_KEY, String(count + 1))
    sessionStorage.setItem(RELOAD_TIME_KEY, String(now))
    window.location.reload()
  }

  // Vue Router のナビゲーションエラーをキャッチ
  if (app.router) {
    app.router.onError((error) => {
      const isChunkError =
        /loading chunk/i.test(error.message) ||
        /ChunkLoadError/i.test(error.name) ||
        /failed to fetch dynamically imported module/i.test(error.message)

      if (isChunkError) {
        reloadIfNeeded()
      }
    })
  }

  // グローバルエラーハンドラー（ルーター外のチャンクエラーもキャッチ）
  window.addEventListener('error', (event) => {
    const errorMessage = event.message || (event.error && event.error.message) || ''
    if (/loading chunk/i.test(errorMessage)) {
      reloadIfNeeded()
    }
  })
}
